import React from 'react';
import PropTypes from 'prop-types';
import { setDataLayer } from 'shared/actions/globals';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import withStatsEvents from 'shared/hocs/stats/withStatsEvents';
import { EVENTS } from 'shared/constants/gtmEvents';

class DealerWebsiteLink extends React.Component {
  static propTypes = {
    events: PropTypes.shape().isRequired,
    dealer: PropTypes.shape().isRequired,
    ClassName: PropTypes.string.isRequired,
    setDataLayer: PropTypes.func.isRequired,
    children: PropTypes.node,
    onClickHandle: PropTypes.func,
  };
  static defaultProps = {
    children: null,
    onClickHandle: () => {},
  };

  setRedirectStats = () => {
    this.props.setDataLayer(EVENTS.dealerSiteRedirect);
    this.props.onClickHandle();
    const { dealer, events } = this.props;
    const { id, title, ga_account: gaAccount } = dealer;
    if (id) {
      events.dispatchDealerRedirectEvent(id);
    }

    const ga = window && window.ga;
    if (ga && gaAccount) {
      ga('send', `redirect`, 'AB_avtosalon', title);
    }
  };

  render() {
    const { ClassName, dealer, children } = this.props;

    if (!dealer) {
      return null;
    }

    const website = dealer && dealer.website ? dealer.website : null;

    return (
      <a
        className={ClassName}
        onClick={this.setRedirectStats}
        href={`${website}`}
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        {children || <FormattedMessage id="Сайт автосалона" />}
      </a>
    );
  }
}

export default connect(
  null,
  { setDataLayer },
)(withStatsEvents(DealerWebsiteLink));



// WEBPACK FOOTER //
// ./src/shared/components/DealerWebsiteLink/DealerWebsiteLink.js